import React, { useState } from 'react'
import Navbar from './Components/layout/navtop/Navtop'
import {
  BrowserRouter as Router,
  Switch,
  Route
} from "react-router-dom";
import { createContext } from 'react'
import Aos from 'aos';
import 'aos/dist/aos.css'

// imported documents
import Footer from './Components/layout/footar/Footer';
import Home from './Components/Pages/Home/Home';
import Shop from './Components/Pages/Shop/Shop';
import Quickview from './Components/Pages/Home/FOT/Quickview';
import ProductDetails from './Components/Pages/ProductDetails/ProductDetails';
import Tooltips from './Components/layout/navtop/Tooltips';
import Blogs from './Components/Pages/Blog/Blogs';
import Blog from './Components/Pages/Blog/Blog';
import About from './Components/Pages/All Pages/About';
import Contact from './Components/Pages/All Pages/Contact';
import Error from './Components/Pages/All Pages/Error';
import FAQ from './Components/Pages/All Pages/Faq';
import Login from './Components/Authencation/Login';

import Checkout from './Components/Authencation/Checkout';
import Profile from './Components/Pages/Profile/Profile';

export const RapperContent = createContext()

const App = () => {
  // useStates
  const [added_products, setAdded_products] = useState([])
  const [added_wish, setAdded_wish] = useState([])
  const [open, setOpen] = useState(false)
  const [toltip, setToltip] = useState(false)
  const [wtoltip, setWtoltip] = useState(false)
  const [quickviewProduct, setQuickviewProduct] = useState({})
  const [authopen, setAuthopen] = useState(false)
  const [loginsuccess, setLoginsuccess] = useState(false)
  // Action handle functions
  const handleClick = (e) => {
    const newarr = [...added_products, e]
    setAdded_products(newarr)
  }
  const handleRemvoe = (e) => {
    const newarr = added_products.filter(pro => e !== pro)
    setAdded_products(newarr)
  }
  const handlewish = (e) => {
    const newarr = [...added_wish, e]
    setAdded_wish(newarr)
  }
  const wishRemvoe = (e) => {
    const newarr = added_wish.filter(pro => e !== pro)
    setAdded_wish(newarr)
  }


  // useEffect
  React.useEffect(() => {
    Aos.init({ duration: 2000 })

    // cheking user log in or not
    const islogin = localStorage.getItem('user')
    
    if(islogin){
     setLoginsuccess(true)
    }
    else{
      setLoginsuccess(false)
    }
  }, [])
  return (
    // provider
    <RapperContent.Provider value={{
      handleClick,
      open, setOpen,
      quickviewProduct, setQuickviewProduct,
      added_products,
      setWtoltip, wtoltip,
      setToltip, toltip,
      handleRemvoe, handlewish,
      wishRemvoe, added_wish,
      authopen, setAuthopen,
      setLoginsuccess, loginsuccess
    }}>
      {/* router */}
      <Router>
        <Navbar />
        <Tooltips />
        <Quickview />
        <Login />
        <Switch>
          <Route exact path="/">
            <Home />
          </Route>
          <Route exact path="/shop">
            <Shop />
          </Route>
          <Route path="/productDetails/:KeyID">
            <ProductDetails />
          </Route>
          <Route exact path="/blog">
            <Blogs />
          </Route>
          <Route path="/blogs/:blogID">
            <Blog />
          </Route>
          <Route path="/about">
            <About />
          </Route>
          <Route path="/contact">
            <Contact />
          </Route>
          <Route path="/faq">
            <FAQ />
          </Route>
          <Route path="/error404">
            <Error />
          </Route>
          <Route path="/profile">
            <Profile />
          </Route>
          <Route path="/checkout">
            <Checkout />
          </Route>
        </Switch>
        <Footer />
      </Router>
    </RapperContent.Provider>
  )
}

export default App
